// extracted by mini-css-extract-plugin
export default {"welcome":"WelcomeWord_welcome__9K66-","title":"WelcomeWord_title__+ZI-B","author":"WelcomeWord_author__UcLkT","author_icon":"WelcomeWord_author_icon__BsKPt"};